<ion-content color="gray" forceOverscroll="false">
  <ion-list mode="ios" lines="none" class="list-content">
    <ion-item mode="md" color="gray" lines="none">
      <ion-img [src]="'Icons.clock' | translate" class="clock"></ion-img>
    </ion-item>

    <ion-item mode="md" color="gray" lines="none" class="ion-text-center">
      <ion-label mode="md" color="darkblue" class="ey-name">
        {{ 'Labels.¡ey-name!' | translate: { nombre: nombre | async} }}
        <p class="we-noticed-you-left">
          <ion-text mode="md" color="status-icon-enable">
            {{ 'Labels.we-noticed-you-left' | translate }}
          </ion-text>
        </p>
      </ion-label>
    </ion-item>

    <ion-item
      mode="md"
      color="gray"
      lines="none"
      class="ion-text-center item-remember-access-temporary"
    >
      <ion-label
        mode="md"
        color="cadet-grey"
        class="remember-access-temporary"
        [innerHtml]="'Labels.remember-access-temporary' | translate | htmlSeguro"
      >
      </ion-label>
    </ion-item>

    <ion-list mode="ios" lines="none">
      <!-- * Boton de renovar token -->
      <ng-container *ngIf="!isRenewToken">
        <ion-item mode="md" color="gray" lines="none">
          <ion-button
            class="btn-return-wa"
            size="default"
            mode="md"
            color="tpcta"
            strong
            (click)="onReNewToken()"
            [disabled]="loading"
          >
            <ng-container *ngIf="loading">
              <ion-spinner name="crescent" slot="start"></ion-spinner>
            </ng-container>

            <ion-label mode="md" color="white" class="return-wa">
              {{ 'Buttons.continue-buying' | translate }}
            </ion-label>
          </ion-button>
        </ion-item>
      </ng-container>

      <!-- * Boton de WA -->
      <ion-item mode="md" color="gray" lines="none">
        <ion-button
          class="btn-return-wa"
          size="default"
          mode="md"
          color="white"
          strong
          (click)="onWA()"
          [disabled]="loading"
        >
          <ion-label mode="md" color="tpcta" class="return-wa">
            {{ 'Buttons.return-wa' | translate }}
          </ion-label>
        </ion-button>
      </ion-item>
    </ion-list>
  </ion-list>

  <ion-item mode="md" color="gray" lines="none">
    <ion-img
      [src]="'Icons.gepp-en-tus-manos' | translate"
      class="gepp-en-tus-manos"
    ></ion-img>
  </ion-item>
</ion-content>
